<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-6">
              <label>Journals</label>
              <select id="lstJournals" class="form-control" onchange="$('#btnGetVolumeIssues').trigger('click');">
                <option selected value="0">All</option>
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.Acronym}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Volume</label>
              <select id="lstVolume" class="form-control" onchange="$('#btnGetArticle').trigger('click');">
                <option selected value="0">All</option>
                <option *ngFor="let item of volumeList" value={{item.VolumeIssue}}>
                  {{item.VolumeIssue}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <label>Article</label>
              <select id="lstArticle" class="form-control">
                <option selected value="0">All</option>
                <option *ngFor="let item of articleList" value={{item.ID}}>
                  {{item.ArticleNo}}
                </option>
              </select>
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
          <br />
          <!--<div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>

            <div class="col-sm-2">
              <button type="button" class="btn btn-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
              <button type="button" class="btn btn-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>-->
        </div>
        <!--<app-articlemeta></app-articlemeta>-->
        <table #dataTable class="display" style="width:100%" id="transactionTable"></table>
        <button type="button" id="btnPopupDT" (click)="showInfoPopUp()" style="display:none">Show</button>
        <button type="button" id="btnUploadDT" (click)="showUpload()" style="display:none">Upload</button>
        <button type="button" id="btnDownloadDT" (click)="download()" style="display:none">Download</button>
        <button type="button" id="btnStart" (click)="start()" style="display:none">Start</button>
        <button type="button" id="btnStartConfirm" (click)="startConfirm()" style="display:none">Start Confirm</button>
        <button type="button" id="btnLoadList" (click)="getTransationList()" style="display:none">Get</button>
        <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>
        <button type="button" id="btnGetArticle" (click)="getArticle()" style="display:none">GetVolumeIssue</button>

        <!--<button type="button" id="ddlNextProcess" (click)="checkNextProcess()" style="display:none">CheckNextProcess</button>-->

        <div id="divArticleInfo" class="modal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header">
                <h4 class="modal-title">Article Details</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <div class="modal-body">
                <app-articleinfo></app-articleinfo>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div id="divFileUpload" class="modal" role="dialog">
          <div class="modal-dialog modal-md">

            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Process Flow</h4>
                <div type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</div>
              </div>
              <div class="modal-body" name="correctionPopup">

                <div class="form-group divImageProcess">
                  <label for="TxtRemarks">Image Count</label>
                  <input type="number"
                         id="TxtImageCount"
                         class="form-control"
                         [(ngModel)]="imageCount"
                         name="imageCount"
                         min="1"
                         (ngModelChange)="onImageCountChange($event)"
                         required />
                </div>


                <div class="form-group divUploadFile">
                  <label for="TxtRemarks">Next Activity</label>
                  <select id="ddlNextActivity" class="form-control">
                    <option selected="selected" value="0">Select</option>
                    <option *ngFor="let item of activityList" value={{item.ID}}>
                      {{item.Activity}}
                    </option>
                  </select>
                </div>
                <div class="form-group divUploadFile">
                  <label for="TxtRemarks">Remarks</label>
                  <textarea class="form-control rounded-0" id="TxtRemarks" rows="5"></textarea>
                </div>
                <div class="form-group" *ngIf="modelItem.LargeUpload=='false'">
                  <label for="FU_Attchment">Completed File</label>
                  <div class="custom-file">
                    <input type="file" id="doc_testfile" (change)="fileUploadChangeEvent($event)" />
                  </div>
                  <!--<app-upload></app-upload>-->
                </div>

                <input type="file" #file id="FilePackage" placeholder="Choose file"
                       (change)="UploadPackage(file.files)"
                       style="display:none;">

              </div>

              <div class="modal-footer">

                <button type="button" class="btn btn-success divUploadFile" id="btnUploadFile" (click)="file.click()"
                        *ngIf="modelItem.LargeUpload=='true'">
                  Upload File
                </button>&nbsp;

                <button type="button" class="btn btn-success waves-effect waves-light divUploadFile"
                        id="btnUpload" (click)="UploadFile()" *ngIf="modelItem.LargeUpload=='false'">
                  Upload File
                </button>

                <button type="button" class="btn btn-success waves-effect waves-light divImageProcess"
                        id="btnUpdateImgP" (click)="UploadFile(1)">
                  Update
                </button>

                <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
            <div id="LoadingImagePopupQC">
              <img src="assets/Images/loader.gif" class="imgLoadimg" />
            </div>
          </div>
        </div>

        <button type="button" id="btnDeleteDT" (click)="RevertArticle()" style="display:none">GetVolumeIssue</button>
        <button type="button" id="btnRevertConfirm" (click)="RevertConfirmArticle()" style="display:none">GetVolumeIssue</button>
        <div class="modal" id="myModal" [style.display]="showModalRevert ? 'block' : 'none'">
          <div class="modal-dialog modal-md custome-modal">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Revert</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hideRevert()">&times;</button>
              </div>
              <!--popup body start-->
              <div class="modal-body" id="popupbody">
                <div class="row">
                  <div class="col-sm-12" id="Instruction">
                    <div class="form-group">
                      <label for="txt_Remarks">Remarks<em>*</em></label>
                      <textarea rows="5" autocomplete="off" class="form-control" id="txt_Remarks"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!--popup body end-->
              <div class="modal-footer">
                <button type="button" class="btn btn-danger waves-effect waves-light" data-dismiss="modal" (click)="hideRevert()">Close</button>
                <button type="button" id="Instructionsave" class="btn btn-success waves-effect waves-light" (click)="RevertConfirmArticle()">Revert</button>
              </div>
              <!--Loading image-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
